import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useHttpClient } from '../../client/HttpClientContext';
import { useRpcClient } from '../../client/useRpcClient';
import { useGetIsUngated } from '../../v2/hooks/useGetIsUngated';
export const useCacheGetter = cache => {
  const httpClient = useHttpClient();
  const rpcClient = useRpcClient();
  const getIsUngated = useGetIsUngated();

  // `useGetIsUngated` returns a fresh callback identity whenever
  // `userInfo.gates` is a new array reference, even if the contents are
  // identical. Stabilize it via a ref so the deps object below stays
  // identity-stable across renders — otherwise consumers that thread the
  // returned getter into a `useAsyncFunction` (e.g. `useSourceId`) re-run
  // the effect every render and infinite-loop.
  const getIsUngatedRef = useRef(getIsUngated);
  useEffect(() => {
    getIsUngatedRef.current = getIsUngated;
  }, [getIsUngated]);
  const stableGetIsUngated = useCallback(gateName => getIsUngatedRef.current(gateName), []);
  const deps = useMemo(() => ({
    httpClient,
    rpcClient,
    getIsUngated: stableGetIsUngated
  }), [httpClient, rpcClient, stableGetIsUngated]);
  return useCallback((key, options) => cache.get(key, deps, options), [cache, deps]);
};